export default __webpack_public_path__ + "static/media/Text_Mining_Jeet_Catherine_GlyGenISB.ad74b742.pdf";